/* Single source of truth for the leadership / team members.
   Used by the listing page (LeadershipTeam) and the per-member
   detail page (TeamMember). Add a new person here with a unique
   `slug` and they automatically get a /about-us/leadership-team/<slug> page. */

import imgDhiraj from '../../images/leadership/dhiraj-jain.jpg';
import imgMamata from '../../images/leadership/mamata-jain.jpg';
import imgJainam from '../../images/leadership/jainam-jain.jpg';
import imgJivika from '../../images/leadership/jivika-jain.png';
import imgPooja from '../../images/leadership/pooja-mam.jpg';

export const FOUNDERS = [
    {
        slug: 'dhiraj-kantilal-jain',
        img: imgDhiraj,
        name: 'Dhiraj Jain',
        role: 'Founder',
        tag: 'Founder',
        bio: "Founder of Jainam Jivika Foundation, driving the vision behind Life Saver Army and the foundation's life-saving mission across India.",
        about: [
            "Dhiraj Jain is a seasoned entrepreneur and strategic architect with over 20 years of experience building companies, developing leaders, and engineering scalable growth across industries. As Founder of 1XL Holdings; a multi-venture ecosystem spanning real estate, mentorship, and innovation; he brings both academic rigour and proven entrepreneurial depth to every endeavour, including his commitment to social impact.",
            "Under his leadership, the Foundation channelled its full focus into Life Saver Army; recognising that solving India's emergency blood shortage required not just compassion, but infrastructure, strategy, and long-term thinking.",
        ],
        quote: {
            text: "Collaboration; We believe teamwork brings out the best in people, tackling even the toughest challenges.",
            by: "Dhiraj Jain",
        },
    },
    {
        slug: 'mamata-dhiraj-jain',
        img: imgMamata,
        name: 'Mamata Dhiraj Jain',
        role: 'Founder',
        tag: 'Founder',
        bio: "Founder, turning the foundation's vision into structured programs and lasting community impact.",
        about: [
            "Mamata Dhiraj Jain's journey; from a small village in India to international recognition as a business leader and social entrepreneur; is a testament to the values she champions: Trust, Growth, Integrity, and Sustainability.",
            "As Founder of 1XL Holdings, Mamata has built a career defined by purposeful leadership. Within Jainam Jivika Foundation, she is the human heartbeat of Life Saver Army; ensuring that partnerships with blood banks, hospitals, NGOs, educational institutions, and elected officials across different states translate into a real, functioning, life-saving network. Her belief is simple: professional excellence and social service are not separate pursuits. They are the same purpose, expressed differently.",
        ],
        quote: {
            text: "Empathy; Understanding the struggles of others is at the core of every initiative we undertake.",
            by: "Mamata Dhiraj Jain",
        },
    },
];

export const TEAM = [
    {
        slug: 'jainam-jain',
        img: imgJainam,
        name: 'Jainam Jain',
        role: 'Founder',
        bio: "At 14, Jainam founded Mengo Engine, an AI marketing platform. A speaker and coach, he brings entrepreneurial energy and digital fluency to Life Saver Army's growth strategy.",
        about: [
            "At 14, Jainam Jain founded Mengo Engine; an AI marketing platform recognised as one of Dubai's most ambitious youth-led startups. A sought-after speaker and leadership coach, he has conducted over 500 offline workshops and 200 webinars, impacting more than 50,000 individuals. Within the Foundation, Jainam brings his entrepreneurial energy and digital fluency to Life Saver Army's growth strategy; from platform innovation to outreach scale.",
        ],
        quote: {
            text: "Success is built not on what you achieve, but on the mindset you shape and the steps you take to turn your dreams into reality.",
            by: "Jainam Jain",
        },
    },
    {
        slug: 'jivika-dhiraj-jain',
        img: imgJivika,
        name: 'Jivika Jain',
        role: 'Founder',
        bio: "A passionate speaker, entrepreneur and coach, Jivika ensures Life Saver Army feels less like a platform and more like a family; where every donor and volunteer is valued.",
        about: [
            "Jivika Jain is a passionate speaker, entrepreneur, and coach who has delivered over 300 in-person workshops and impacted more than 90,000 lives across her initiatives. As Community Lead at the Foundation, she ensures that Life Saver Army feels less like a platform and more like a family; one where every donor is celebrated, every volunteer is supported, and every act of generosity is met with genuine gratitude.",
        ],
        quote: {
            text: "Every challenge we face is an opportunity to grow. I'm here to help you turn that spark into a blazing fire.",
            by: "Jivika Jain",
        },
    },
    {
        slug: 'pooja-rathore',
        img: imgPooja,
        name: 'Pooja Rathore',
        role: 'Chief Executive Officer',
        bio: "A social entrepreneur, digital strategist and passionate changemaker creating sustainable social impact through innovation, technology and community engagement.",
        about: [
            "Ms. Pooja Rathore is a social entrepreneur, digital strategist, and passionate changemaker dedicated to creating sustainable social impact through innovation, technology, and community engagement. As the Chief Executive Officer of Jainam Jivika Foundation, she leads the Foundation's strategic initiatives, transforming ideas into scalable programmes that empower communities and inspire volunteer-driven action.",
            "With expertise in digital marketing, grassroots advocacy, and social leadership, Ms. Rathore has successfully built partnerships across NGOs, educational institutions, hospitals, and volunteer networks. Under her leadership, Life Saver Army has evolved into a technology-enabled initiative focused on ensuring timely access to blood while fostering a nationwide culture of voluntary blood donation and civic responsibility.",
        ],
        quote: {
            text: "Leadership; We believe lasting change begins by empowering people, building purposeful collaborations, and creating solutions that serve generations.",
            by: "Pooja Rathore",
        },
    },
];

export const ALL_MEMBERS = [...FOUNDERS, ...TEAM];

export const findMember = (slug) => ALL_MEMBERS.find((m) => m.slug === slug);
